import { httpClient } from '@/services/http/httpClient'
import type { FileType } from '@/types/fileType'
import type { Option } from '@/types/option'
import type { IdeaStatus } from '../types'

type UpdateIdeaParams = {
  id: string
  status: IdeaStatus
  title: string
  sequence?: string
  description: string
  challengeId: string
  participants?: string[]
  fileType?: FileType
  links?: Option[]
  ideaFields?: {
    id: string
    fieldValue: {
      id?: string
      values: string
    }
  }[]
}

export async function updateIdea({
  id,
  title,
  description,
  sequence,
  status,
  challengeId,
  fileType,
  participants,
  links,
  ideaFields,
}: UpdateIdeaParams) {
  const payload = new FormData()

  payload.append('title', title)
  payload.append('description', description)
  payload.append('campaignId', challengeId)
  payload.append('status', status)

  if (sequence && sequence !== '') {
    payload.append('sequence', sequence)
  }

  if (fileType?.file) {
    payload.append('files', fileType.preview ?? fileType.file)
  }

  if (participants?.length) {
    payload.append('ideaUsers', JSON.stringify(participants))
  }

  if (links?.length) {
    const mappedLinks = links.map((link, index) => ({
      id: link.value || String(index + 1),
      name: `Link ${index + 1}`,
      url: link.label,
    }))

    payload.append('externalLinks', JSON.stringify(mappedLinks))
  }

  if (ideaFields?.length) {
    const mappedIdeaFieldsValue = ideaFields.map((ideaField) => ({
      id: ideaField.id,
      fieldValue: {
        id: ideaField.fieldValue.id,
        values: ideaField.fieldValue.values,
      },
    }))

    payload.append('ideaFields', JSON.stringify(mappedIdeaFieldsValue))
  }

  await httpClient.patch(`/ideas/ideas/${id}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
